export default (): URLSearchParams => new URLSearchParams(window.location.search);
